export interface NavLinksProps {
  label: string;
  href: string;
}

export const HomeNav: NavLinksProps[] = [
  {
    label: "Study Local",
    href: "/explore-universities?type=Local",
  },
  {
    label: "Study Overseas",
    href: "/explore-universities?type=Overseas",
  },
  {
    label: "Career Test",
    href: "/career-test",
  },
  // {
  //     label: "Partners",
  //     href: "#partners"
  // },
  {
    label: "Course Finder",
    href: "/course-finder",
  },
  {
    label: "Careers",
    href: "/careers",
  },
];

export const CareerNav: NavLinksProps[] = [
  {
    label: "Home",
    href: "/",
  },
  {
    label: "About",
    href: "#about",
  },
  {
    label: "Why Join Us",
    href: "#why",
  },
  {
    label: "Open Roles",
    href: "#roles",
  },
  {
    label: "Locations",
    href: "#locations",
  },
];
